var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOlho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 782.58 518.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 259.12,
    x2: 782.58,
    y2: 259.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006ce4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00337c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overview-2",
    "data-name": "Overview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overview_Vertical",
    "data-name": "Overview Vertical"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.59,259.14c0-96.48,78.21-174.7,174.7-174.7s174.7,78.21,174.7,174.7-78.21,174.7-174.7,174.7-174.7-78.21-174.7-174.7ZM391.29,518.24c-174.41,0-352.37-164.84-372.08-183.64-12.41-12.4-19.21-28.72-19.21-45.99v-58.99c0-17.27,6.71-33.49,18.88-45.68C38.69,165.07,216.89,0,391.29,0s352.35,164.83,372.07,183.63c12.51,12.5,19.21,28.72,19.21,46v58.99c0,17.27-6.71,33.5-18.88,45.67-19.8,18.88-197.95,183.96-372.4,183.96ZM391.29,38.56c-129.45,0-278.07,108.74-345.47,172.98-4.59,4.6-7.26,11.21-7.26,18.09v58.99c0,6.98,2.7,13.51,7.6,18.4,67.25,64.1,215.69,172.67,345.14,172.67s278.07-108.74,345.47-172.99c4.59-4.6,7.26-11.21,7.26-18.09v-58.99c0-6.92-2.66-13.42-7.49-18.3-67.32-64.12-215.9-172.76-345.24-172.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.69,283.26l-45.09,45.09c-8.6,8.68-12.88,19.95-12.88,31.21l-.04,73.43c-5.73.58-11.51.87-17.37.87s-11.72-.29-17.45-.87v-73.43c0-11.26-4.28-22.52-12.88-31.21l-45.09-45.09c-13.34-13.34-13.34-34.95,0-48.33l45.09-45.04c8.6-8.68,12.88-19.95,12.88-31.17v-73.43c5.73-.58,11.55-.87,17.45-.87s11.68.29,17.41.87v73.43c0,11.22,4.28,22.48,12.88,31.17l45.09,45.04c13.34,13.38,13.34,34.99,0,48.33Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlho);
export default __webpack_public_path__ + "static/media/olho.644f69255e8d4d3359e47fe29b7908b3.svg";
export { ForwardRef as ReactComponent };